export function createFile(bits, name, options) {
  // https://pqina.nl/blog/rename-a-file-with-javascript/
  try {
    // If this fails, we go for Blob
    return new File(bits, name, options);
  } catch (e) {
    // If we're here a new File could not be constructed
    var myBlob = new Blob(bits, options || {});
    myBlob.lastModified = new Date();
    myBlob.name = name;
    return myBlob;
  }
}

export function runFunctionIf(func, condition, cb) {
  if (condition) {
    func(cb);
  } else {
    cb();
  }
}

export function toURLEncodedString(obj) {
  return Object.keys(obj).map(function (k) {
    return encodeURIComponent(k) + '=' + encodeURIComponent(obj[k])
  }).join('&');
}

export function isEqual(obj1, obj2) {
  // Get the keys of both objects
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  // If number of properties is different, objects are not equal
  if (keys1.length !== keys2.length) {
    return false;
  }

  // Iterate through properties
  for (const key of keys1) {
    const val1 = obj1[key];
    const val2 = obj2[key];
    const areObjects = isObject(val1) && isObject(val2);

    // If both values are objects, recursively check equality
    // If values are not objects, check direct equality
    if (
      (areObjects && !isEqual(val1, val2)) ||
      (!areObjects && val1 !== val2)
    ) {
      return false;
    }
  }

  // If all properties matched, objects are equal
  return true;
}

// Helper function to check if a value is an object
export function isObject(object) {
  return object != null && typeof object === 'object';
}




// WEBPACK FOOTER //
// ./src/util/dataHelpers.js